/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The KeysPartnerBody model module.
 * @module model/KeysPartnerBody
 * @version 1.0.0
 */
export class KeysPartnerBody {
  /**
   * Constructs a new <code>KeysPartnerBody</code>.
   * @alias module:model/KeysPartnerBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>KeysPartnerBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/KeysPartnerBody} obj Optional instance to populate.
   * @return {module:model/KeysPartnerBody} The populated <code>KeysPartnerBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new KeysPartnerBody();
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} title
 */
KeysPartnerBody.prototype.title = undefined;

/**
 * @member {String} description
 */
KeysPartnerBody.prototype.description = undefined;

/**
 * @member {Boolean} enabled
 */
KeysPartnerBody.prototype.enabled = undefined;

